module.exports = __webpack_public_path__ + "img/food1.af3569fc.png";